import { Api } from "../../index";
import { API_GET_LOOKUP_VALUES, API_POST_INSURED_ADDRESS_DETAILS } from "../../Apis/ApiEndPoints";
import {
  IAsyncLabelFn,
  IAsyncOptionFn,
  IGetOptionsResponse,
} from "../../models/user/DynamicForm/DynamicForm";
import { IGetInsuredAddressDetailsResponse } from "../../models/user/Vehicle/Vehicle";
import { VoiceFormPolicyContext } from "./voiceFormRegistry";

export type VoiceFormAsyncFns = {
  asyncOptionsFunctions: Record<string, IAsyncOptionFn>;
  asyncLabelFunctions?: Record<string, IAsyncLabelFn>;
};

async function lookupOptions(
  fieldName?: string
): Promise<IGetOptionsResponse["data"]> {
  const key = fieldName?.trim() || "";
  if (!key) return [];
  const response = await Api.get<IGetOptionsResponse>(
    `${API_GET_LOOKUP_VALUES}/${key}`
  );
  return response.data?.data ?? [];
}

export function buildAddVehicleAsyncFns(
  policy: VoiceFormPolicyContext
): VoiceFormAsyncFns {
  const asyncOptionsFunctions: Record<string, IAsyncOptionFn> = {
    getVehicleOwnershipOptions: (fieldName) => lookupOptions(fieldName),
    getVehicleUsageOptions: (fieldName) => lookupOptions(fieldName),
    getInterestTypes: (fieldName) => lookupOptions(fieldName),
  };

  const asyncLabelFunctions: Record<string, IAsyncLabelFn> = {
    getGarageLocation: async () => {
      try {
        const response = await Api.post<IGetInsuredAddressDetailsResponse>(
          API_POST_INSURED_ADDRESS_DETAILS,
          {
            policyId: policy.policyId,
            carrier: policy.carrier,
            system: policy.system,
            lobCode: policy.lobCode,
          }
        );
        const addr = response.data?.data?.address;
        if (!addr) return "";
        return `${addr.addr1} ${addr.city} ${addr.stateProvCd} ${addr.postalCode}`.trim();
      } catch {
        return "";
      }
    },
  };

  return { asyncOptionsFunctions, asyncLabelFunctions };
}

export function buildAddDriverAsyncFns(): VoiceFormAsyncFns {
  const names = [
    "getPrefixOptions",
    "getMaritalStatusOptions",
    "getGenderOptions",
    "getRelationshipToInsuredOptions",
    "getEmploymentStatusOptions",
    "getEducationLevelOptions",
    "getLicensingStateOptions",
    "getDriverLicenseStatusOptions",
  ];
  const asyncOptionsFunctions: Record<string, IAsyncOptionFn> = {};
  for (const name of names) {
    asyncOptionsFunctions[name] = (fieldName) => lookupOptions(fieldName);
  }
  return { asyncOptionsFunctions };
}
